<template>
<div>
  <confirm ref="confirm"></confirm>
  <span id="demo22"></span>

  <form id="myForm" :action="actionlink()" method="post" target="_blank">
    <input id="inputsaveurl" type="hidden" name="saveurl" >
    <input id="inputdata" type="hidden" name="data" >
  </form>

    <v-select hide-details v-model="item" :items="items" item-text="TemplateName" item-value="TemplateId" label="Pdf Şablon" return-object>
    </v-select>


    <v-dialog v-model="pdfdialog" width="570px" height="850px">
      <div id="my-container">
        <iframe src="" height="810" width="550" type="application/pdf">
          </iframe>
      </div>
    </v-dialog>

</div>
</template>

<script>
import auth from "../../../../api/auth.js"
import tool from "../tools";
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import confirm from "@/components/app/coper/comp/confirm.vue";

export default {
  props: ["value", "dizayngrupadi", "objectname", "menudisable"],
  components: {
    customdialog,
    confirm
  },

  computed: {
    DizaynId: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      }
    },

    item: {
      get: function () {
        return this.fitem;
      },
      set: function (newValue) {
        if (newValue != undefined && newValue.id != undefined && newValue.id > 0) {
          this.DizaynId = newValue.id.valueOf();
        }
        this.fitem = newValue;
      }
    },

    GetDizaynGrupAdi: {
      get: function () {
        var r = this.dizayngrupadi;
        return r;
      }
    },

    GetMenuDisable: {
      get: function () {

        if (this.menudisable == undefined) {
          return "";
        } else {
          return "display:none;";
        }

      }
    },

    GetObjectName: {
      get: function () {
        var r = this.objectname;
        return r;
      }
    }

  },
  watch: {
    DizaynId: function (id) {
      this.ItemBul(id)
    },

  },
  data() {
    return {
      items: [],
      fitem: {},
      dialogEkle: false,
      dialogEdit: false,
      pdfdialog: false,

      dizaynAdi: "",
      dizaynParametre: "",
      resolve: null,
      reject: null,
      prm: {},
      Guid: "",
      saveurl: "",
      ilkYukleme: true,

    };
  },
  created: function () {
    this.sablonGetir();
  },
  methods: {

    actionlink() {
      return auth.REPORTBRO_URL + "/DesignShow"
    },

    ItemBul(id) {
      if (this.fitem == undefined || this.fitem.id != id) {
        var found = this.items.find(function (element) {
          return element.id == id;
        });

        if (found == undefined)
          this.item = {};
        else
          this.item = found;

      }
    },

    Print(val) {
      this.prm = prm;
      var prm = {
        SablonId: this.DizaynId,
        PrintObjectName: null, //this.GetObjectName, // "Controllers.ReportBro.InvoicePrint",
        IsTestData: false,
        Prm: val
      };
      this.Send(prm);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
 

    DesignShow(evt) {
      this.Guid = "";
      tool
        .api_post(this, "ReportBro/TableDesignRead", {
          value: this.item.id,
        })
        .then(
          response => {

            document.getElementById("inputsaveurl").value = auth.API_URL + "api/ReportBro/DesignSave?id=" + this.item.id + "&bearer=" + auth.getAuthHeader();
            document.getElementById("inputdata").value = response.body;
            evt.preventDefault();
            document.getElementById("myForm").submit();
          },
          response => {}
        );

    },
    Uygula() {
      tool
        .api_post(this, "ReportBro/GetReportBroGetDesign", {
          key: this.Guid,
        })
        .then(
          response => {
            this.dizaynParametre = response.body;
          },
          response => {}
        );
    },

    sablonGetir() {
      tool
        .api_post(this, "ReportBro/GetReportBroDesignGrupAll", {
          id: 0,
          ad: this.GetDizaynGrupAdi,
          objectName: this.GetObjectName
        })
        .then(
          response => {
            this.items = response.body;
            if ((this.ilkYukleme) && (this.DizaynId > 0)) {
              this.ItemBul(this.DizaynId);
            } else {
              if (this.items.length > 0) {
                this.item = this.items[0];
              } else {
                this.item = null;
              }
            }
            this.ilkYukleme = false;
          },
          response => {
            this.items = [];
          }
        );
    },

    Send(prm) {
      tool.api_post_FileDownload(this, "ReportBro/ReportBroPrintPdf", prm).then(
        response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });

          //console.log(blob);

          //var link = document.createElement("a");
          //link.href = window.URL.createObjectURL(blob);
          //link.download = "rapor.pdf";
          //link.click();

          //var url = URL.createObjectURL(blob);
          //var printWindow = window.open(url, '', 'width=800,height=500');
          //printWindow.print()

          var file = window.URL.createObjectURL(blob);
          document.querySelector("iframe").src = file;
          this.pdfdialog = true;

          this.resolve(true);
        },
        response => {
          this.resolve(false);
        }
      );
    }
  }
};
</script>
